export const subscription = {
  titles: {
    subscription: "Assinatura",
    freeTrial: "Teste grátis",
    expired: "Expirado",
  },

  status: {
    active: "Ativa",
    canceled: "Cancelada",
    trialAccess: "TESTE GRÁTIS",
    expiredAccess: "ACESSO EXPIRADO",
  },

  notices: {
    activeDesc: "Gerencie os detalhes da sua assinatura e as opções de upgrade.",
    canceledDesc:
      "Sua assinatura foi cancelada. Você manterá o acesso até a data de término.",
    trialDesc: "Você tem acesso aos recursos do sistema até a data de expiração.",
    expiredDesc:
      "Seu período de teste terminou. Assine para continuar usando o serviço.",
    upgradeHint:
      "Não perca o acesso aos recursos avançados, faça o upgrade da sua assinatura agora",
    expiredHint:
      "Seu acesso expirou. Assine para continuar usando todos os recursos",
    needFullAccess: "Precisa de acesso completo?",
    choosePlan: "Escolha um plano que combine com você",
  },

  labels: {
    planActive: "Plano ativo",
    stateNow: "Status atual",
    trialPeriod: "Período de teste",
    periodExpired: "Período expirado",
    summary: "Resumo da assinatura",
    timeLeft: "Tempo restante",
    trialExpiresIn: "Seu teste grátis expira em {days} dias",
    expirationDate: "Data de expiração",
    nextRenewal: "Próxima renovação",
    accessUntil: "Acesso disponível até",
    perUnit: "/ Por {unit}",
    unitRoom: "Quarto",
    unitRoomMultiple: "Vários quartos",
    unitApartment: "Apartamento",
    unitVilla: "Vila",
    unitCamping: "Camping",
    unitLodging: "Hospedagem",
    annualPlan: "Plano anual",
    monthlyPlan: "Plano mensal",
  },

  actions: {
    addUnit: "Adicionar {unitLabel}",
    manageSubAndPayment: "Gerenciar assinatura e forma de pagamento",
    processing: "Processando...",
    subscribeNow: "Assinar agora",
    chooseAPlan: "Escolher um plano",
    goToSubscriptionPage: "Ir para os planos",
  },

  confirmCancel: {
    title: "Cancelar assinatura?",
    text: "Se você cancelar, perderá o acesso aos seus serviços.",
    confirm: "Sim, cancelar",
    cancel: "Não",
  },

  formats: {
    priceTotalHTML: "{price}",
    dateDDMMYYYY: "{date}",
  },

  modal: {
    title: 'Assinatura ativada!',
    details: "Detalhes da assinatura",
    welcomeTitle: "Bem-vindo ao WA Checkin {plan}!",
    welcomeBody:
      "Agora você tem acesso completo às nossas ferramentas de check-in por WhatsApp, sincronização com OTAs, chatbot com IA, automações e muito mais.",
    feature1: {
      title: "Gerencie tarifas e disponibilidade",
      desc: "Edite seus preços com facilidade e controle a ocupação em tempo real, tudo em um só lugar.",
    },
    feature2: {
      title: "Receba reservas diretas",
      desc: "No seu próprio site, os hóspedes podem reservar diretamente sem passar pelas OTAs.",
    },
    schedule: {
      help: "Agende uma videochamada gratuita e ajudamos você a configurar tudo.",
      cta: "Agendar videochamada",
    },
  },

  sectionPlans: {
    title: "Lista de planos",
    confirm: {
      header: "Confirmar upgrade de plano",
      loadingMsg: "Atualizando seu plano, aguarde.",
      body: "Você está prestes a alterar o plano da sua conta para {plan}.",
    },
    actions: {
      cancel: "Cancelar",
      confirmUpgrade: "Confirmar upgrade",
      goToBilling: "Ir para formas de pagamento",
      accept: "OK",
      updateSubscription: "Atualizar assinatura", // NEW
    },
    success: {
      title: "Sucesso",
      body: "Sua assinatura foi atualizada.",
    },
    errors: {
      processTitle: "Erro ao processar a solicitação",
      unknownUpdate: "Erro desconhecido ao atualizar a assinatura.",
      genericTitle: "Erro",
      genericBody: "Não foi possível atualizar a assinatura.",
    },
  },

  plans: {
    features: {
      installation: "Onboarding personalizado com um especialista",
      fastSupport: "Suporte rápido por e-mail, chat e telefone",
      whatsappCheckin: "Check-in via WhatsApp",
      linkEmailCheckin: "Check-in via link / e-mail",
      welcomeMessage: "Mensagem de boas-vindas por WhatsApp e e-mail",
      digitalSignature: "Assinatura digital das políticas",
      idScanner: "Scanner de documento/passaporte",
      sesHospedajesSend: "Envio automático de relatórios à polícia",
      reviewLink: "Enviar link de avaliação do Google após o check-out",
      smartLocks: "Conecte suas fechaduras inteligentes",
      channelManager1: "Channel Manager (conexão com 1 OTA)",

      includesLite: "Tudo do Lite",
      selfieVerification: "Verificação do hóspede no check-in com selfie",
      unifiedInbox: "Caixa de entrada unificada",
      upsellServices: "Ofereça serviços e experiências via WhatsApp",
      paymentLinks: "Cobranças de hóspedes (link de pagamento com cartão)",
      websiteBookings: "Site de reservas com calendário sincronizado",
      channelManagerUnified: "Channel Manager (calendários unificados, mais de 100 OTAs)",
      channelManagerCentralPrices:
        "Channel Manager (gestão de preços centralizada)",
      guestSupportOption: "Opção de contratar o Suporte ao Hóspede",

      includesStandard: "Tudo do Standard",
      centralizedPriceManager: "Gestor de preços centralizado",
      aiChatbot: "Chatbot com IA no WhatsApp (FAQ e automação)",
      googleVacationRentals: "Integração com o Google Vacation Rentals",
      whatsappReminders: "Lembretes por WhatsApp para hóspedes",
      eInvoicingSoon: "Faturamento eletrônico (em breve)",
      prioritySupport: "Suporte prioritário",
    },
  },

  planCard: {
    perSlash: "/por", // separator "/per {unit}"
    infoTitle: "Detalhes do plano",
    update: "Atualizar",
    subscribe: "Assinar",
    currentPlan: "Plano atual",
    byApartment: "por apartamento",
    byVilla: "por vila",
    byCamping: "por camping",
    byRoom: "por quarto",
    byUnit: "por unidade",
  },

  services: {
    title: "Serviços adicionais",
    ctaComingSoon: "Em breve",
    guestSupport: {
      title: "Serviço de Suporte ao Hóspede",
      subtitle: "Cuidamos do WhatsApp e das ligações dos seus hóspedes por você.",
      desc: "Ajudamos com o check-in, respondemos às dúvidas e também atendemos as ligações de reservas diretas. Você relaxa enquanto eles têm uma experiência nota 10 desde o primeiro contato.",
    },
    chatbot: {
      title: "ChatBot com IA",
      activeService: "Serviço ativo",
      desc: "Adicione o serviço de chatbot com IA e automatize as dúvidas dos seus hóspedes de forma rápida e eficiente.",
      activateCta: "Ativar serviço",
      confirm: {
        header: "Confirmar ativação",
        loadingMsg: "Ativando o serviço de ChatBot, aguarde.",
        body: "Você está prestes a ativar o serviço de ChatBot com IA para suas {units} propriedades.",
      },
      discount: {
        applied: "Desconto aplicado:",
        couponFallback: "Cupom",
      },
      pricing: {
        unitPrice: "Preço unitário:",
        quantity: "Quantidade:",
        totalToPay: "Total a pagar:",
      },
    },
  },

  invoices: {
    title: "Faturas e recibos",
    created: "Criada",
    status: "Status",
    amount: "Valor",
    paid: "Paga",
    unpaid: "Não paga",
    viewInvoice: "Ver fatura",
    empty: "Você ainda não tem faturas.",
  },

  updateModal: {
    header: "Adicionar {unitLabel}s",
    body: "Adicione a quantidade de {unitLabelPlural} à sua assinatura.",
    pricing: {
      discountApplied: "Desconto aplicado à assinatura:",
      unitPrice: "Preço unitário:",
      quantity: "Quantidade:",
      totalNewUnits: "Total das novas unidades:",
      newSubscriptionTotal: "Novo valor total da assinatura:",
    },
    prorationNote:
      "As alterações na assinatura são cobradas proporcionalmente com base nos dias restantes do período atual. A cobrança integral será aplicada no mês seguinte.",
  },

  page: {
    findRightPlan: "Encontre o plano ideal para você",
    enterAmount: "Insira a quantidade",
    numberOf: "Número de {unit}"
  },
  billing: {
    title: "Selecione o período de cobrança",
    subtitle: "Escolha como você quer pagar",
    monthly: "Mensal",
    annual: "Anual",
    discountShort: "−{percent}%",
  },
};
